import actions from "./actions";

const {
    CRYPTO_CLIENTS_OVERVIEW_DATA_BEGIN,
    CRYPTO_CLIENTS_OVERVIEW_DATA_SUCCESS,
    CRYPTO_CLIENTS_OVERVIEW_DATA_ERR
} = actions

const initialState = {
    data: [],
    url: null,
    fileLoading: false,
    loading: false,
    error: null,
};

const cryptoClientsOverviewReducer = (state = initialState, action) => {
    const {type, data, err} = action;
    switch (type) {
        case CRYPTO_CLIENTS_OVERVIEW_DATA_BEGIN:
            return {
                ...state,
                overviewLoading: true,
            };
        case CRYPTO_CLIENTS_OVERVIEW_DATA_SUCCESS:
            return {
                ...state,
                overviewData: data,
                overviewError: false,
                overviewLoading: false,
            };
        case CRYPTO_CLIENTS_OVERVIEW_DATA_ERR:
            return {
                ...state,
                overviewError: err,
                overviewLoading: false,
            };
        default:
            return state;
    }
}

export default cryptoClientsOverviewReducer;